const externalLinkButton = "_uihe296iy0";
const contentCls = "_uihcbyqvdz";
const iframeWrapperCls = "_uihiycyz3l";
const errorMessageCls = "_uihe13ro89t";
const errorMessageButtonCls = "_uiheg0bc0u";
const FADE_TRANSITION_DURATION_MS = 200;
const fadeInCls = "_uihfsv2ckz";

export { FADE_TRANSITION_DURATION_MS, contentCls, errorMessageButtonCls, errorMessageCls, externalLinkButton, fadeInCls, iframeWrapperCls };
import "./comp.content.style.linaria.module.css";
//# sourceMappingURL=comp.content.style.js.map
